<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <divisoria-descricao-contrato
            :titulo="!filial && tipoProposta === 'constituicao' ? 'Sócios' : 'Contratante'"
            :descricao="getTextoGrupoContratante"
            :alterar-informacao="filial && tipoProposta === 'constituicao'"
            :item="valueInner.alteracaoContratante"
            :mensagem-alerta="filial && tipoProposta === 'constituicao'"
            @alterar-dados="alterarDadosContratante"
          >
            <template slot="complemento-numero">
              <div class="circle">
                1
              </div>
            </template>
          </divisoria-descricao-contrato>
        </b-col>
      </b-row>
      <b-row
        v-if="!filial && tipoProposta === 'constituicao'"
        class="mb-50"
      >
        <b-col>
          <div
            v-for="(socio, $index) in valueInner.socios"
            :key="$index"
          >
            <socio-empresa
              :ref="`socio${socio.code}`"
              :socio="socio"
              :desabilitar-nome="((socio.veioDoHub && socio.dadosSocio) || !socio.dadosSocio) && !habilitarCampo"
              :mostrar-ocultar="true"
              :disabled="(socio.veioDoHub) || ((!socio.dadosSocio && ((filial && !valueInner.primeiraBuscaMatriz) || (valueInner.enviadoParaAnalise))) && !habilitarCampo) || (!habilitarCampo && !socio.dadosSocio)"
              :showinfo="true"
              :habilitar-campo="habilitarCampo"
              :desabilita-anexo="!socio.dadosSocio && !habilitarCampo"
              :lista-emails="valueInner.socios"
              @adicionar-item="adicionarItem($event)"
              @remover-item="removerItem($index)"
              @adicionar-contratante="adicionarContratante($event)"
              @editar-socio="alterarDadosSocio"
              @ocultar-socio="ocultarSocioPregeracao"
            />
          </div>
        </b-col>
      </b-row>

      <b-row
        v-if="filial && tipoProposta === 'constituicao'"
        class="mb-50"
      >
        <b-col cols="12">
          <b-form-group>
            <b-row style="display: flex;align-items: center;">
              <b-col cols="auto">
                <b-form-group label="CPF sócio">
                  <inscricao-federal
                    v-model="valueInner.cpfResponsavelRFB"
                    :disabled="!dadosContratante && !habilitarCampo"
                  />
                </b-form-group>
              </b-col>
              <div>
                <i>
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                  Informe primeiramente o CPF do sócio que é responsavel perante a RFB
                </i>
              </div>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        v-if="filial && tipoProposta === 'constituicao'"
        class="mb-50"
      >
        <b-col>
          <b-row>
            <b-col cols="4">
              <b-form-group label="CNPJ Matriz">
                <b-input-group>
                  <inscricao-federal
                    ref="cadastroFederal"
                    v-model="valueInner.inscricaoCNPJMatriz"
                    :tipo-inscricao="'cnpj'"
                    :disabled="!dadosContratante && !habilitarCampo"
                    class="form-control"
                    @change="mudadoCNPJ(valueInner)"
                  />
                  <b-input-group-append>
                    <b-button
                      v-b-tooltip.hover
                      title="Busca dados da RFB"
                      :variant="valueInner.erroNavegacaoMatriz || valueInner.atualizar ? 'danger' : 'primary'"
                      style="float:right"
                      :disabled="!dadosContratante && !habilitarCampo"
                      @click="buscarSocios(valueInner.inscricaoCNPJMatriz)"
                    >
                      <feather-icon
                        v-if="!buscaSocios"
                        icon="SearchIcon"
                      />
                      <feather-icon
                        v-if="!valueInner.erroNavegacaoMatriz && buscaSocios"
                        icon="CheckIcon"
                      />
                      <feather-icon
                        v-if="valueInner.erroNavegacaoMatriz && buscaSocios"
                        icon="RotateCwIcon"
                      />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Razão social">
                <b-form-input
                  v-model="valueInner.nomeEmpresarialCNPJ"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="Tipo">
                <b-form-input
                  v-model="valueInner.matrizFilialCNPJ"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <small
            v-if="valueInner.erroNavegacaoMatriz"
            class="text-danger"
          >Não foi possível concluir a busca de dados na RFB, verifique o CNPJ informado e tente novamente!</small>
          <small v-else-if="tipoProposta === 'constituicao' && filial && valueInner.matrizFilialCNPJ === 'Filial'">Atenção: em propostas de Constituição de filial deve ser informado o CNPJ de Matriz para a busca de dados na RFB!</small>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <divisoria-descricao-contrato
            :titulo="!filial && tipoProposta === 'constituicao' ? 'Contratante' : 'Sócios'"
            :descricao="getTextoGrupoSocio"
          >
            <template slot="complemento-numero">
              <div class="circle">
                2
              </div>
            </template>
          </divisoria-descricao-contrato>
        </b-col>
      </b-row>

      <b-row v-if="!filial && tipoProposta === 'constituicao'">
        <b-col cols="3">
          <b-form-group label="CPF">
            <inscricao-federal
              :value="valueInner.cpfResponsavelRFB"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col cols="9">
          <b-form-group label="Sócio">
            <b-input
              v-model="valueInner.nomeContratante"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="filial && tipoProposta === 'constituicao'">
        <b-col>
          <div
            v-for="(socio, $index) in valueInner.socios"
            :key="$index"
          >
            <socio-empresa
              :ref="`socio${socio.code}`"
              :socio="socio"
              :desabilitar-nome="(socio.veioDoHub && socio.dadosSocio) || !socio.dadosSocio && !habilitarCampo"
              :mostrar-ocultar="true"
              :disabled="(socio.veioDoHub) || ((!socio.dadosSocio && ((filial && !valueInner.primeiraBuscaMatriz) || (valueInner.enviadoParaAnalise))) && !habilitarCampo) || (!habilitarCampo && !socio.dadosSocio)"
              :showinfo="true"
              :desabilita-anexo="!socio.dadosSocio && !habilitarCampo"
              :lista-emails="valueInner.socios"
              @adicionar-item="adicionarItem($event)"
              @remover-item="removerItem($index)"
              @editar-socio="alterarDadosSocio"
              @ocultar-socio="ocultarSocioPregeracao"
            />
          </div>
        </b-col>
      </b-row>

      <certificado-e-anexo
        ref="anexos"
        v-model="valueInner.anexosECertificado"
        :pre-geracao-id="valueInner.id"
        :tipo-proposta="tipoProposta"
        :filial="filial"
        :desabilitar-campos="(valueInner.enviadoParaAnalise && !habilitarCampo) || !habilitarCampo"
      />

      <b-row class="mt-1">
        <b-col>
          <divisoria-descricao-contrato
            :titulo="'Outras informações'"
            :descricao="'Informe o e-mail para recebimento dos boletos e NFs'"
            :alterar-informacao="true"
            :item="valueInner.altercaoDataInicio"
            @alterar-dados="alterarDadosDataInicio"
          >
            <template slot="complemento-numero">
              <div class="circle">
                5
              </div>
            </template>
          </divisoria-descricao-contrato>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <div style="display: flex">
            <div>
              <legend style="font-size: 14px;">
                Data de início na Auditar</legend>
            </div>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover
                title="Aqui deve ser informado a data de início na Auditar, essa data é o início da Responsabilidade Técnica da Auditar."
                style="font-size: 0.65rem;"
                class="question-icon"
              >
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
              </i>
            </div>
          </div>
          <validation-provider
            #default="{ errors }"
            rules="required"
            :name="'Data de início'"
          >
            <data-input
              v-model="valueInner.dataInicio"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="12">
          <email-input
            :value="valueInner.emailsBoletosNFs"
            :require="!pendenteAnalise"
            :disabled="((valueInner.enviadoParaAnalise && !dadosDataInicio) && !habilitarCampo) || (!habilitarCampo && !dadosDataInicio)"
            @input="adicionarEmail($event)"
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-form-group
          label="Descrição (opcional)"
          class="col-12"
        >
          <b-textarea
            v-model="valueInner.descricao"
          />
        </b-form-group>
      </b-row>

      <loading
        :is-loading="isLoading"
        :cancelar-upload="cancelarBusca"
        :show-message="'Prezado, estamos buscando os dados. Aguarde!'"
      />
      <template-contrato-proposta
        :value="valueInner"
        :proposta-valor="propostaValor"
        :proposta-template="propostaTemplate"
        :proposta-id="propostaId"
        :habilitar-campo="habilitarCampo"
        :proposta-contrato="propostaContrato"
        @contrato-alterado="$emit('contrato-alterado', $event)"
      />
    </b-col>
  </b-row>
</template>

<style lang="scss">
.circle {
  width: 25px;
  height: 25px;
  line-height: 25px;
  border: 1px solid #5e5873;
  border-radius: 50%;
  text-align: center;
  color: #5e5873;
  display: inline-block;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import { generateCode } from '@core/utils/utils'
import { ValidationProvider } from 'vee-validate'
import apiPreGeracao from '@/app-modulo/comercial/cadastro-proposta/shared/components/pre-geracao-contrato-proposta/services/api'

export default {
  name: 'ConstituicaoMatriz',
  components: {
    ValidationProvider,
    FontAwesomeIcon,
    DivisoriaDescricaoContrato: () => import('@/shared/components/divisoria-descricao-contrato/DivisoriaDescricaoContrato.vue'),
    SocioEmpresa: () => import('@/shared/components/socio-empresa-contrato/SocioEmpresaContrato.vue'),
    CertificadoEAnexo: () => import('../certificado-e-anexos/CertificadoEAnexos.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
    TemplateContratoProposta: () => import('../template-contrato-proposta/TemplateContratoProposta.vue'),
    InscricaoFederal: () => import('@/shared/components/inscricao-federal/InscricaoFederal.vue'),
    EmailInput: () => import('@/@pilar/components/email-input/EmailInput.vue'),
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    filial: {
      type: Boolean,
      default: false,
    },
    tipoProposta: {
      type: String,
      default: '',
    },
    propostaContrato: {
      type: String,
      default: '',
    },
    habilitarCampo: {
      type: Boolean,
      default: false,
    },
    propostaValor: {
      type: Number,
      default: 0,
    },
    propostaTemplate: {
      type: String,
      default: '',
    },
    propostaId: {
      type: Number,
      default: 0,
    },
    pendenteAnalise: {
      type: Boolean,
      default: false,
    },
    dadosSocio: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faQuestionCircle,
      dadosContratante: false,
      dadosDataInicio: false,
      isLoading: false,
      buscaSocios: false,
      valueInner: {
        contratoSubstituir: '',
        emailsBoletosNFs: [],
        empresas: [],
        inscricaoCNPJMatriz: null,
        socios: [{
          cpf: null,
          dadosSocio: false,
          tipoInscricao: 'cpf',
          veioDoRFB: false,
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
          atualizarDados: false,
          code: generateCode(),
        }],
        anexosECertificado: {
          certificadoSelecionado: false,
          contratualSelecionado: false,
          outrosSelecionado: false,
          certificado: [],
          senhaCertificado: null,
          tipoCertificado: null,
          dataVencimentoCertificado: null,
          certificadoFisico: null,
          nomeArquivoContratual: null,
          nomeArquivoOutrosAnexos: null,
          nomeArquivoCertificado: null,
        },
      },
      invalidTags: [],
      duplicateTags: [],
    }
  },
  computed: {
    getTextoGrupoContratante() {
      if (!this.filial && this.tipoProposta === 'constituicao') {
        return 'Aqui você pode adicionar os sócios com suas informações detalhadas'
      }
      return 'Nos contratos de constituição de Filial, informe o CNPJ da Matriz nos dados do contratante'
    },
    getTextoGrupoSocio() {
      if (!this.filial && this.tipoProposta === 'constituicao') {
        return 'Nos contratos de constituição de Matriz, contratante é vinculado de forma automática ao marcar o sócio como responsável perante a RFB'
      }
      return 'Aqui você pode adicionar os sócios com suas informações detalhadas'
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
        this.adicionarContratanteExistente()
        if (this.valueInner.socios.length < 1) {
          this.adicionarItem()
        }
      }
    },
  },
  created() {
    this.valueInner = this.value
    this.adicionarContratanteExistente()
  },
  methods: {
    adicionarEmail(value) {
      this.valueInner.emailsBoletosNFs = value
    },
    adicionarContratanteExistente() {
      if (this.valueInner.socios && this.valueInner.socios.length > 0) {
        const socio = this.valueInner.socios.find(find => find.responsavelRFB)
        if (socio) {
          this.$set(this.valueInner, 'cpfResponsavelRFB', socio.inscricao)
          this.$set(this.valueInner, 'nomeContratante', socio.nome)
        }
      }
    },
    adicionarContratante(value) {
      if (value.responsavel && !this.filial && this.tipoProposta === 'constituicao') {
        this.$set(this.valueInner, 'cpfResponsavelRFB', value.contratante.inscricao)
        this.$set(this.valueInner, 'nomeContratante', value.contratante.nome)
      } else if (!value.responsavel && !this.filial && this.tipoProposta === 'constituicao') {
        this.valueInner.cpfResponsavelRFB = null
        this.valueInner.nomeContratante = null
      }
    },
    adicionarItem() {
      const item = {
        veioDoRFB: false,
        veioDoHub: false,
        dadosSocio: this.dadosSocio,
        tipoInscricao: 'cpf',
        cpf: null,
        ocultarDoContrato: false,
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
        atualizarDados: false,
        code: generateCode(),
      }
      this.valueInner.socios.push(item)
      if (this.valueInner.socios && this.valueInner.socios.length > 1) {
        this.$emit('editar-socio')
      }
    },
    removerItem(index) {
      this.valueInner.socios.splice(index, 1)

      if (this.valueInner.socios.length === 0) {
        this.adicionarItem()
      }
      this.$emit('editar-socio')
    },
    alterarDadosSocio(item) {
      const socio = this.valueInner.socios.find(find => find.id === item.id)
      this.$set(socio, 'dadosSocio', true)
      this.$emit('editar-socio')
    },
    alterarDadosContratante(mensagem) {
      this.$set(this.valueInner, 'alteracaoContratante', {
        justificativa: mensagem,
        usuCadastro: this.valueInner.alteracaoContratante.usuCadastro,
        dataCadastro: this.valueInner.alteracaoContratante.dataCadastro,
      })
      this.dadosContratante = true
    },
    alterarDadosDataInicio(mensagem) {
      this.dadosDataInicio = true
      this.$set(this.valueInner, 'altercaoDataInicio', {
        justificativa: mensagem,
        usuCadastro: this.valueInner.altercaoDataInicio.usuCadastro,
        dataCadastro: this.valueInner.altercaoDataInicio.dataCadastro,
      })
    },
    buscarSocios(inscricao) {
      this.buscaSocios = true
      this.isLoading = true
      // eslint-disable-next-line global-require
      const axios = require('axios')
      if (inscricao && inscricao !== '' && this.valueInner.cpfResponsavelRFB !== '') {
        const idEmpresa = this.valueInner.empresas[0] ? this.valueInner.empresas[0].empresaId : null
        apiPreGeracao.getSociosMatriz({
          cadastroFederal: inscricao,
          constituicao: true,
          cadastroPessoa: this.valueInner.cpfResponsavelRFB,
          empresaId: idEmpresa,
        }, axios.CancelToken)
          .then(payload => {
            const dados = payload.data
            this.$set(this.valueInner, 'nomeEmpresarialCNPJ', dados.nomeEmpresarialCNPJ)
            this.$set(this.valueInner, 'matrizFilialCNPJ', dados.matrizFilialCNPJ)
            this.$set(this.valueInner, 'erroNavegacaoMatriz', dados.erroNavegacaoMatriz)

            this.isLoading = false
            this.valueInner.primeiraBuscaMatriz = true

            if (dados.empresas && dados.empresas.some(som => som.inscricao)) {
              const item = this.valueInner.empresas[0]
              if (item) {
                dados.empresas[0].empresaId = item.empresaId
              }
              this.valueInner.empresas = dados.empresas
            }

            if (this.valueInner.socios.length > 0 && this.valueInner.socios.some(som => som.nome && som.nome !== '')) {
              this.valueInner.socios = this.valueInner.socios.filter(filter => !filter.veioDoRFB && !filter.veioDoHub)
              dados.socios.forEach(socio => {
                this.valueInner.socios.push(socio)
              })
            } else {
              this.encontradoSocios = (dados.socios && dados.socios.length > 0)

              if (this.valueInner.socios.length < 1) {
                this.adicionarItem()
              }

              if (this.encontradoSocios) {
                this.valueInner.socios = dados.socios
              }
            }
          }).catch(err => {
            throw err
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    mudadoCNPJ(valor) {
      this.$set(valor, 'atualizar', true)
    },
    cancelarBusca() {
      this.$emit('closeInCancel')
      this.isLoading = false
      apiPreGeracao.cancelarBusca()
    },
    retornaTodosArquivos() {
      const arquivos = []
      for (let index = 0; index < this.valueInner.socios.length; index += 1) {
        const { code } = this.valueInner.socios[index]
        if (this.$refs[`socio${code}`] && this.$refs[`socio${code}`][0]) {
          const arquivo = this.$refs[`socio${code}`][0].$refs[`upload${code}`].value[0]
          if (arquivo) {
            arquivos.push({
              file: arquivo.file,
              nome: `${code};${arquivo.filename || arquivo.name}`,
            })
          }
        }
      }
      return arquivos
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    mascaraCadFederal() {
      return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return erro.replace('The', '').replace('field is required', 'é um campo obrigatório')
      }
      return erro
    },
    mudarParaLowerCase(value) {
      const emails = []
      value.forEach(each => emails.push(each.toLowerCase()))
      this.valueInner.emailsBoletosNFs = emails
    },
    ocultarSocioPregeracao() {
      this.$emit('editar-socio')
    },
  },
}
</script>
